import { useTranslation } from "react-i18next";
import { Group } from "@lib/store";
import { Button, GroupAvatar } from "@molecules";
import { H4 } from "@quarks";
import { useModal } from "@hooks";
import { GroupInviteModal } from "../GroupInviteModal";

export const GroupInviteItem = ({ group }: { group: Group }) => {
  const { t } = useTranslation();
  const { addPages, openModal } = useModal();

  const acceptedMembers = group.members.filter(member => member.status === "Accepted");

  return (
    <div className="grid grid-cols-[auto_1fr] gap-4 items-center w-full py-4 last:pb-0">
      <GroupAvatar
        group={group}
        size="large"
        className="shadow-mapiq-small"
      />

      <div className="flex flex-col">
        <H4>{group.name}</H4>
        <p className="text-mapiq-black-500">{t("groups:Member", { count: acceptedMembers.length })}</p>
      </div>

      <div className="col-start-2 flex items-center gap-4">
        <Button
          button="primary"
          size="small"
          onClick={() => {
            addPages([<GroupInviteModal groupInvite={group} />]);
            openModal();
          }}>
          {t("groups:ShowInvite")}
        </Button>
      </div>
    </div>
  );
};
